/* ═══════════════════════════════════════════════════════════════
   Time & Expense rebuild (Tranche 4) — one draft-state text/number
   input. Local draft state; commits on blur/Enter only, matching the
   HourCell convention from Tranche 2 (never a save per keystroke).
   ═══════════════════════════════════════════════════════════════ */

import React, { useEffect, useState } from 'react';
import { Input, InputProps } from '../../components/ui/input';

export interface DraftFieldProps extends Omit<InputProps, 'value' | 'onChange' | 'onBlur'> {
  value: string;
  onCommit: (value: string) => void;
}

export function DraftField({ value, onCommit, ...rest }: DraftFieldProps) {
  const [draft, setDraft] = useState(value);
  const [focused, setFocused] = useState(false);

  // Sync from the committed value whenever it changes elsewhere (another
  // client, a reload) — but never clobber active typing.
  useEffect(() => {
    if (!focused) setDraft(value);
  }, [value, focused]);

  return (
    <Input
      {...rest}
      value={draft}
      onFocus={(e) => {
        setFocused(true);
        rest.onFocus?.(e);
      }}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={() => {
        setFocused(false);
        if (draft !== value) onCommit(draft);
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.currentTarget.blur();
        } else if (e.key === 'Escape') {
          setDraft(value);
          e.currentTarget.blur();
        }
        rest.onKeyDown?.(e);
      }}
    />
  );
}
